//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import StockControlMixin from './StockControlMixin.js'

export default {
  name: 'StockControlMobile',
  components: {
    StockConfigurationDepartmentSelector
  },
  mixins: [StockControlMixin],
  props: {
    stockControl: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      tools: []
    }
  },
  computed: {
    hasEditAccess: function () {
      return !this.readonly // TODO
    }
  },
  created: function () {
    let tools = this.stockControl.tools || []
    tools = JSON.parse(JSON.stringify(tools))
    tools = tools.map(tool => this.itemMapper(tool))
    this.tools = tools
  },
  methods: {
    // @Override
    getItems: function () {
      return this.tools
    },
    // @Override
    onUpdateRecord: function () {
      // TODO
    },
    // @Override
    onRecordCreated: function (recordId) {
      // TODO
    },
    // @Override
    onDepartmentsChanged: function (recordId) {
      // TODO
    }
  }
}

